/** InsCoder WANG.J 2026-09-17 B + HP 26 comparison banner: the description row opens the modal **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hp-26-brand-modal';
  var TRIGGER_SELECTOR = '[data-hp26-bm-trigger]';
  var MODAL_SELECTOR = '[data-hp26-bm-modal]';
  var CLOSE_SELECTOR = '[data-hp26-bm-close]';
  var BODY_LOCK_CLASS = 'overflow-hidden';

  function isVisible(el) {
    return !!el && el.offsetParent !== null;
  }

  function initSection(root) {
    if (!root || root.dataset.hp26BmReady === 'true') return;

    var trigger = root.querySelector(TRIGGER_SELECTOR);
    var modal = root.querySelector(MODAL_SELECTOR);
    if (!trigger || !modal) return;
    root.dataset.hp26BmReady = 'true';

    var closers = Array.prototype.slice.call(modal.querySelectorAll(CLOSE_SELECTOR));
    var closeButtons = closers.filter(function (el) {
      return el.tagName === 'BUTTON';
    });

    function openModal() {
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add(BODY_LOCK_CLASS);

      /** Close button differs per breakpoint (PC inside the card, mobile below it) **/
      var visibleClose = closeButtons.filter(isVisible)[0];
      if (visibleClose) visibleClose.focus();
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(BODY_LOCK_CLASS);
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);

    closers.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root =
      target.classList && target.classList.contains('hp-26-brand-modal')
        ? target
        : target.querySelector(ROOT_SELECTOR);
    if (root) initSection(root); else initAll();
  });
})();
/** InsCoder WANG.J 2026-09-17 E + HP 26 comparison banner: the description row opens the modal **/
